import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="site-header">
      <div className="header-inner">
        <div className="header-content">
          <h1>Phoenix Players Earlsdon</h1>
        </div>
      </div>
    </header>
  );
}

export default Header;
